var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgPinFull = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 20,
  height: 20,
  fillRule: "evenodd"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "m13.556 3.425 2.97 2.978a1.63 1.63 0 0 1 0 2.3 1.62 1.62 0 0 1-2 .23L12 11.466a3.73 3.73 0 0 1-.494 4.642.37.37 0 0 1-.263.108.37.37 0 0 1-.264-.108l-3.282-3.29L3.527 17 3 16.471l4.173-4.18-3.282-3.29a.373.373 0 0 1 0-.529 3.71 3.71 0 0 1 4.645-.495l2.525-2.531a1.63 1.63 0 0 1 1.069-2.411 1.62 1.62 0 0 1 1.426.39"
})));
export default SvgPinFull;